import './GalleryImage.scss';
import React, { Component } from 'react';
import DemoImage from '../DemoImage';


export default class GalleryImage extends Component {
  render() {
    let className = (this.props.className || '') + ' imgw';
    let containerStyle = {
      width: '100%',
      height: '100%',
      boxSizing: 'border-box',
      overflow: 'hidden'
    };
    return( 
      <div className={className} style={this.props.style} >
        <DemoImage {...this.props} style={{}} className="gallery-img rel-img" imageClassName="cover" containerClassName="cover" containerStyle={containerStyle}>{this.props.children}</DemoImage>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/components/GalleryImage/GalleryImage.js
 **/